/* eslint-disable class-methods-use-this */
import { JwtPayload } from '@REDUCERS';
import jwt_decode from 'jwt-decode';

const USER_KEY = `user-${process.env.NODE_ENV}`;

const VERSION = 3;

interface Data {
    payload: string;

    VERSION: number;

    EXPIRY: number;
}

class UserRepository {
    getData(): string | undefined {
        const data = localStorage.getItem(USER_KEY);

        if (!data) return;

        try {
            const parsedData: Data = JSON.parse(data);

            if (parsedData.VERSION !== VERSION) {
                this.clear();

                return;
            }

            return parsedData.payload;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }

    setData(data: string): void {
        if (!data) return;
        const decoded: JwtPayload = jwt_decode(data);
        const EXPIRY = decoded.exp;

        localStorage.setItem(USER_KEY, JSON.stringify({
            payload: data,
            VERSION,
            EXPIRY,
        }));
    }

    isExpired(): boolean {
        const data = localStorage.getItem(USER_KEY);

        if (data) {
            try {
                const currentTime = Math.floor(Date.now() / 1000);
                const parsedData: Data = JSON.parse(data);
                return currentTime > parsedData.EXPIRY;
            } catch (e) {
                //
            }
        }

        return true;
    }

    clear(): void {
        localStorage.removeItem(USER_KEY);
    }
}

export default new UserRepository();
